<template>
  <div>
    <b-row>
      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>
      <b-col xl="12">
        <b-card no-header>
          <b-form>
            <b-form-group
              label="Nro Plan"
              label-for="numero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Inicial"
              label-for="fechaVencimientoInicial"
              :labelCols="labelCols"
              description="Fecha de vencimiento de la primer cuota"
              horizontal>
              <b-form-input 
                id="fechaVencimientoInicial" 
                v-model="fechaVencimientoInicial" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cuotas"
              label-for="cantidadCuotas"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="cuotas"
                v-model.trim="$v.cantidadCuotas.$model" 
                :state="cantidadCuotasValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cantidadCuotasFeedback">
                {{ cantidadCuotasInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Capital"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Intereses"
              label-for="importeIntereses"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importeIntereses"
                v-model.trim="$v.importeIntereses.$model" 
                :state="importeInteresesValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeInteresesFeedback">
                {{ importeInteresesInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <br>

            <app-banco-cuenta
              label="Cuenta"
              :nombre="bancoCuentaNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import { required, decimal, numeric, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'planPagos/getField',
  mutationType: 'planPagos/updateField',
});

export default {
  name: 'PlanPagosABM',
  components: {
    appBancoCuenta: BancoCuenta,
  },
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      noValidar: true,
      numeroValido: null,
      numeroInvalidoMsj: '',
      cantidadCuotasValida: null,
      cantidadCuotasInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      importeInteresesValido: null,
      importeInteresesInvalidoMsj: '',
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'numero',
      'fechaVencimientoInicial',
      'cantidadCuotas',
      'importe',
      'importeIntereses',
      'bancoCuenta',
      'bancoCuentaNombre',
    ])
  },  
  created() {
    this.getDatosAdicionales();
    
    this.$store.dispatch('planPagos/inicializar')
      .catch(error => this.showAlertError(error));
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj) {
      this.alertMsj = alertMsj;
      this.alertVariant = 'light';
      this.dismissCountDown = this.alertCountDown;
    },
    showAlertError(alertMsj) {
      this.alertMsj = alertMsj;
      this.alertVariant = 'danger';
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this

      let params = {
        monedaId: 101
      }

      vm.$store.dispatch('bancoscuentas/getList', params)
        .then(() => {
          vm.bancosCuentas = this.$store.getters['bancoscuentas/list'];
          vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList'];
        })
        .catch(() => this.showAlertError('Se produjo un error al recuperar la información de cuentas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          if (!this.$v.numero.required) {
            this.numeroInvalidoMsj = 'Debe ingresar el número de plan';
          } else if (!this.$v.numero.maxLength) {
              this.numeroInvalidoMsj = 'El número del plan de pagos puede contener hasta 50 caracteres';
          }     
        } else {
          this.numeroValido = null;
          this.numeroInvalidoMsj = '';
        }
      }

      if (campo == 'cantidadCuotas' || validarTodos) {
        if (this.$v.cantidadCuotas.$error) {
          this.cantidadCuotasValida = false;
          if (!this.$v.cantidadCuotas.numeric) {
            this.cantidadCuotasInvalidaMsj = 'El número de cuotas debe ser un valor numérico';
          } else if (!this.$v.cantidadCuotas.minValue) {
              this.cantidadCuotasInvalidaMsj = 'El número de cuotas no es válido';
          }     
        } else {
          this.cantidadCuotasValida = null;
          this.cantidadCuotasInvalidaMsj = '';
        }
      }
      
      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de capital debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe de capital no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }

      if (campo == 'importeIntereses' || validarTodos) {
        if (this.$v.importeIntereses.$error) {
          this.importeInteresesValido = false;
          if (!this.$v.importeIntereses.decimal) {
            this.importeInteresesInvalidoMsj = 'El importe de intereses debe ser un valor numérico';
          } else if (!this.$v.importeIntereses.minValue) {
              this.importeInteresesInvalidoMsj = 'El importe de intereses no es válido';
          }     
        } else {
          this.importeInteresesValido = null;
          this.importeInteresesInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let bancoCuenta;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }
      this.$store.dispatch('planPagos/setBancoCuenta', bancoCuenta);

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.$emit('planPagosAgregado', 
            this.$store.getters['planPagos/planPagos']);
        } 
      }
    },
    bancoCuentaActualizada(nombre) {
      this.bancoCuentaNombre = nombre;
    },
    goBack() {
      this.$emit('cancel');
    }
  },
  validations: {
    numero: {
      required,
      maxLength: maxLength(50)
    },
    importe: {
      decimal,
      minValue: minValue(0)
    },
    importeIntereses: {
      decimal,
      minValue: minValue(0)
    },
    cantidadCuotas: {
      numeric,
      minValue: minValue(1)
    },
  },  
}
</script>

<style>
</style>
